import { Trans, useTranslation } from 'next-i18next/pages';
import React from 'react';

import { useFlavorFromRoute } from '@pflegia/ui/hooks/use-flavor-from-route';
import HowItWorksCta from '@pflegia/ui/shared/landing-page/how-it-works-cta/HowItWorksCTA.component';

import pointingRightImage from '@public/assets/female-pointing-right-with-bubble.png';
import pointingUpFullImage from '@public/assets/female-pointing-up-full.png';

import { FUNNEL } from '@shared/application/constants';
import { RegisterButtonTrackingIds } from '@shared/application/marketing/events/register-button';
import { useTracking } from '@shared/application/tracking.service';

import { HowItWorksProps } from './HowItWorks';

type HowItWorksSignUpButtonIds = RegisterButtonTrackingIds.LandingPageHowItWorks | RegisterButtonTrackingIds.BlogHowItWorks;

interface HowItWorksCtaProps extends Pick<HowItWorksProps, 'employerLayout'> {
  registerButtonId?: HowItWorksSignUpButtonIds;
  altDesktopImage?: string;
  altMobileImage?: string;
}

const PflegiaHowItWorksCta: React.FC<HowItWorksCtaProps> = ({ employerLayout, registerButtonId, altDesktopImage, altMobileImage }) => {
  const { t } = useTranslation('landingPage', { keyPrefix: `howItWorks.${employerLayout ? 'employer' : 'guest'}.ctaCard` });
  const { signupButtonClickTrackEventRegistration } = useTracking();
  const { sourceDomainName, isPraxia } = useFlavorFromRoute();

  return (
    <HowItWorksCta
      desktopImage={pointingRightImage}
      mobileImage={pointingUpFullImage}
      altDesktopImage={altDesktopImage}
      altMobileImage={altMobileImage}
      subtitle={t(`body${isPraxia ? 'Praxia' : ''}`)}
      title={t('title', { domain: sourceDomainName })}
      href={employerLayout ? '#' : FUNNEL}
      guestContent={
        <Trans
          components={{ span1: <span className='text-main-blue' />, span2: <span className='hidden lg:inline' /> }}
          i18nKey='content'
          t={t}
        />
      }
      employerLayout={employerLayout}
      onClick={() => registerButtonId && !employerLayout && signupButtonClickTrackEventRegistration(registerButtonId)}
    />
  );
};

export default PflegiaHowItWorksCta;
